import React, { useContext } from 'react';
import './NoX.scss';

import { ThemeContext } from '../../store/ThemeProvider';
import chroma from 'chroma-js';

interface INoX {
  image?: any;
  text?: string;
}
const NoX = function(props: INoX) {
  const { componentColor, h1Color } = useContext(ThemeContext);

  const renderImage = () => {
    return props.image ? { backgroundImage: props.image } : {};
  };
  return (
    <div style={{ backgroundColor: componentColor, padding: '50px 0 30px' }}>
      <div className="gallery-list-empty" style={renderImage()} />
      {!!props.text && (
        <div
          className="empty-tips"
          style={{
            color: chroma(h1Color)
              .alpha(0.6)
              .css()
          }}
        >
          {props.text}
        </div>
      )}
    </div>
  );
};

export default NoX;
